import { CallableInput } from "Components/Shared";
import AuthenticationSelect from "Components/Shared/AuthenticationSelect";
import AvayaMonitorSelect from "Components/Shared/AvayaMonitorSelect";
import FormSubmit from "Components/Shared/FormSubmit";
import SimpleDeviceFormLayout from "Components/Shared/SimpleDeviceFormLayout";
import WebhookTypeSelect from "Components/Shared/WebhookTypeSelect";
import { Field, Formik } from "formik";
import { useWebhook } from "Hooks/Endpoints";
import APIAccountWebhookProvider from "Providers/APIWebhookProvider";
import React, { useState } from "react";
import { Form } from "semantic-ui-react";
import { object, string } from "yup";

const WebhookCreate = () => {
  const [authType, setAuthType] = useState("DISABLED");
  const [appType, setAppType] = useState("ivr.generic");

  const { save, createHook, uncreate } = useWebhook();

  const getSchema = () => {
    const yupURL = string().required("A IP/URL is required");
    if (authType === "KEY") {
      return object().shape({
        url: yupURL,
        apiKeyName: string().required(),
        apiKeyValue: string().required(),
      });
    } else if (authType === "KEY_SECRET") {
      return object().shape({
        url: yupURL,
        apiKeyName: string().required(),
        apiKeyValue: string().required(),
        apiSecretName: string().required(),
        apiSecretValue: string().required(),
      });
    } else if (authType === "BASIC_AUTH") {
      return object().shape({
        url: yupURL,
        apiSecretName: string().required(),
        apiSecretValue: string().required(),
      });
    } else if (authType === "OAUTH") {
      return object().shape({
        url: yupURL,
        apiSecretName: string().required(),
        apiSecretValue: string().required(),
      });
    } else if (authType === "DISABLED") {
      return object().shape({
        url: yupURL,
      });
    }
  };

  const isApiKeyNameVisible = authType === "KEY" || authType === "KEY_SECRET";
  const isApiKeyValueVisible = authType === "KEY" || authType === "KEY_SECRET";
  const isApiSecretNameVisible =
    authType === "BASIC_AUTH" ||
    authType === "KEY_SECRET" ||
    authType === "OAUTH";
  const isApiSecretValueVisible =
    authType === "BASIC_AUTH" ||
    authType === "KEY_SECRET" ||
    authType === "OAUTH";

  return (
    <APIAccountWebhookProvider>
      <SimpleDeviceFormLayout
        beanName='Webhook'
        actionType='Create'
        onBack={uncreate}
      >
        <Formik
          initialValues={createHook}
          validationSchema={getSchema()}
          onSubmit={(values, actions) => {
            save(values);
          }}
        >
          {(props: any, values: any) => (
            <Form onSubmit={props.handleSubmit}>
              <WebhookTypeSelect
                name='app'
                label='Application'
                onChange={(value: string) => setAppType(value)}
              />
              <Field
                name='url'
                label='URL'
                placeholder='https://myplugin.com'
                component={CallableInput}
              />
              <AuthenticationSelect
                name='authType'
                label='Authentication Type'
                onChange={(value: string) => setAuthType(value)}
              />
              {isApiKeyNameVisible && (
                <Field
                  label='Key Name'
                  type='text'
                  name='apiKeyName'
                  placeholder='myKeyName'
                  component={CallableInput}
                />
              )}
              {isApiKeyValueVisible && (
                <Field
                  label='Key Value'
                  type='text'
                  name='apiKeyValue'
                  placeholder='myKeyValue'
                  component={CallableInput}
                />
              )}
              {isApiSecretNameVisible && (
                <Field
                  label='Secret Name'
                  type='text'
                  name='apiSecretName'
                  placeholder='mySecretKeyName'
                  component={CallableInput}
                />
              )}
              {isApiSecretValueVisible && (
                <Field
                  label='Secret Value'
                  type='text'
                  name='apiSecretValue'
                  placeholder='mySecretKeyValue'
                  component={CallableInput}
                />
              )}
              {appType === "event.custom.sleektech" && (
                <Field
                  label='Tenant ID'
                  type='text'
                  name='meta.tenant_id'
                  component={CallableInput}
                />
              )}
              {appType === "event.custom.sleektech" && (
                <Field
                  label='Login TTL'
                  type='number'
                  name='meta.loginTTL'
                  placeholder='14400'
                  component={CallableInput}
                />
              )}
              {(appType === "integration.avayaR11" ||
                appType === "integration.avayaR9") && (
                <>
                  <AvayaMonitorSelect
                    label='Monitor Instance(s)'
                    name='meta.monitor'
                  />
                  {appType === "integration.avayaR11" && (
                    <>
                      <Field
                        label='Avaya Username'
                        name='meta.username'
                        component={CallableInput}
                      />
                      <Field
                        label='Avaya Password'
                        name='meta.password'
                        component={CallableInput}
                      />
                    </>
                  )}
                </>
              )}
              <FormSubmit
                name='Create Webhook'
                onCancel={uncreate}
                errors={props.errors}
              />
            </Form>
          )}
        </Formik>
      </SimpleDeviceFormLayout>
    </APIAccountWebhookProvider>
  );
};

export default WebhookCreate;
